import { render } from "./InputTextArea.vue?vue&type=template&id=196dac62&scoped=true"
import script from "./InputTextArea.vue?vue&type=script&lang=js"
export * from "./InputTextArea.vue?vue&type=script&lang=js"

import "./InputTextArea.vue?vue&type=style&index=0&id=196dac62&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196dac62"]])

export default __exports__